import ThankYouPage from './ThankYouPage'

const ArchitectureNewQuoteThankYou = () => (
    <ThankYouPage returnPath="/architecture" contentCategory="Architecture" />
)

export default ArchitectureNewQuoteThankYou
